module.exports = __webpack_public_path__ + "static/media/filipe-vellasco.e9072570.png";